import { FRONT } from '../../constants/product.constants';
export function getCustomStoreProductDefaultImage(mockups) {
  const mockup = mockups.find(mockup => mockup.location === FRONT);
  const defaultMockup = mockups && mockups[0] && mockups[0].fileName || '';
  return mockup ? mockup.fileName : defaultMockup;
}